import React from "react";
import TwoFactor from "src/components/settings/security/TwoFactor";
import ChangePassword from "../changePassword/ChangePassword";
import WebAuthnManagement from "./WebAuthnManagement";
import { getSessionItem } from "src/utils/SessionManagement";
import { AccountLock } from "./AccountLock/AccountLock";

const Security = () => {
  const pkFeatureEnabled = getSessionItem("features")?.includes("passkey");
  const accountLockFeatureEnabled = getSessionItem("features")?.includes("account-lock");
  return (
    <>
      <TwoFactor />
      {accountLockFeatureEnabled && <AccountLock />}
      {pkFeatureEnabled && <WebAuthnManagement />}
      <ChangePassword />
    </>
  );
};

export default Security;
